// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box[data-v-e4bce9da] {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.box > div[data-v-e4bce9da] {
  flex: 1;
  width: 100%;
}
.box .top[data-v-e4bce9da] {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/EnterpriseQuota/QuotaHistory.vue","webpack://./QuotaHistory.vue"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;ACAF;ADPA;EASI,OAAA;EACA,WAAA;ACCJ;ADXA;EAaI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;ACCJ","sourcesContent":["\n.box {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n  > div {\n    flex: 1;\n    width: 100%;\n  }\n  .top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n",".box {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 10px;\n}\n.box > div {\n  flex: 1;\n  width: 100%;\n}\n.box .top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
